import React, { Component, Input, useEffect, useState } from "react";
import { Col, Row, Container, Button, Modal } from "react-bootstrap";
import QrCode from "../../assets/components/QRCode/QrCode";
import QrCodeTicket from "../../assets/QRCodeTicket/QRCodeTicket";
import "./profil.css";
import { Redirect } from "react-router-dom";
import Image from "react-bootstrap/Image";

function UploadPicture() {
  const [imageStorage, setImageStorage] = useState("");
  const [images, setImages] = useState("");
  const [label, setLabel] = useState("");
  const [message, setMessage] = useState("");
  const [dailyMenu, setDailyMenu] = useState({});

  const getMonProfil = () => {
    const headers = new Headers({
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),

      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurant", options)
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          setImages(responseObject.logo);
        },

        (error) => {
        }
      );
  };

  const modifProfilLogo = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);

    const headers = new Headers({
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "PUT",
      body: data,
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/restaurateur/profil/edit/logo",
      options
    )
      .then((response) => {
        return response.json();
      })

      .then(
        (responseObject) => {
          setMessage(responseObject.message);
          const headers = new Headers({
            Authorization: "Bearer " + localStorage.getItem("token"),
            "x-restaurant-id": localStorage.getItem("restaurantId"),

            "X-Requested-With": "XMLHttpRequest",
          });

          const options = {
            method: "GET",
            headers: headers,
          };

          fetch(
            process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurant",
            options
          )
            .then((response) => {
              return response.json();
            })
            .then(
              (responseObject) => {
                setImageStorage(responseObject.logo);
                getMonProfil();
              },

              (error) => {
              }
            );
        },

        (error) => {
        }
      );
  };

  useEffect(() => {
    getMonProfil();
  }, []);

  return (
    <Col className="addImage">
      <h1 className="title">Mon Logo </h1>
      <form onSubmit={modifProfilLogo} className="formLogo">
        <img
          className="restaurantLogo"
          src={process.env.REACT_APP_BACKEND_URL + images}
        ></img>
        <br />
        <br />
        <input
          type="file"
          name="file"
          onChange={(e) => {
            setImageStorage(e.target.files[0]);
          }}
        />
        <br />
        <button className="buttonVal" type="submit">
          Valider
        </button>
      </form>
    </Col>
  );
}

class Profil extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profil: {},
      editing: true,
      show: false,
      redirect: false,
      checkGeneral: false,
      checkIndividuel: false,
    };
  }

  handleShow = () => {
    this.setState({ show: true });
  };
  handleClose = () => {
    this.setState({ show: false });
  };
  // renderButtonSub = () => {
  //   if (this.state.profil.abonne === true) {
  //     return (
  //       <div>
  //         <button
  //           className="signOut button"
  //           variant="primary"
  //           onClick={() => {
  //             this.props.history.push("/dataClient");
  //           }}>
  //           Accès à mon espace premium <br />
  //         </button>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div>
  //         <button
  //           className="signOut button"
  //           variant="primary"
  //           onClick={() => {
  //             this.props.history.push("/abonnement");
  //           }}>
  //           Souscrire à l'abonnement Premium <br />
  //         </button>
  //       </div>
  //     );
  //   }
  // };
  buttonEdit = () => {
    if (this.state.editing == true) {
      return (
        <>
          <button
            className="button"
            onClick={() => {
              this.setState({ editing: false });
            }}
          >
            Modifier <br />
          </button>
        </>
      );
    } else {
      return (
        <button className="button" onClick={this.putProfilOnClick}>
          Confirmer Modification
        </button>
      );
    }
  };

  buttonCancel = () => {
    if (this.state.editing == false) {
      return (
        <button
          className="button"
          onClick={() => {
            this.setState({ editing: true });
            this.getMonProfil();
          }}
        >
          Annuler
        </button>
      );
    }
  };

  handleInput = (event) => {
    let profil = this.state.profil;
    profil[event.target.name] = event.target.value;
    this.setState({
      profil: profil,
      // identifier name de l'input = choisir la valeur qui se trouve dans l'input
    });
  };

  /* Affichage Profil */
  getMonProfil = () => {
    const headers = new Headers({
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),

      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    // Cette page édite UNIQUEMENT le restaurant courant (les données du compte
    // se modifient sur la page "Mon compte").
    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurant", options)
      .then((response) => response.json())
      .then((resto) => {
        localStorage.setItem("propsRestaurant", resto.restaurantName);
        this.setState({
          profil: resto,
          checkGeneral: resto.pourboireGeneral,
          checkIndividuel: resto.pourboireIndividuel,
        });
      });
  };

  unSubscription = () => {
    const headers = new Headers({
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "POST",
      headers: headers,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/delete", options)
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          this.setState({ profil: responseObject });
        },

        (error) => {
        }
      );
  };

  /* Modification du restaurant courant (/restaurant/edit) */
  modifProfil = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const restoData = {
      restaurantName: this.state.profil.restaurantName,
      adress: this.state.profil.adress,
      city: this.state.profil.city,
      postal: this.state.profil.postal,
      pourboireGeneral: this.state.checkGeneral,
      pourboireIndividuel: this.state.checkIndividuel,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/restaurateur/restaurant/edit", {
      method: "PUT",
      body: JSON.stringify(restoData),
      headers: headers,
    })
      .then((response) => response.json())
      .then((restoResp) => {
        this.setState({ message: restoResp.message, editing: true });
        // met à jour le nom/ville dans le sélecteur/localStorage si changé
        try {
          const restos = JSON.parse(localStorage.getItem("restaurants") || "[]");
          const id = localStorage.getItem("restaurantId");
          const idx = restos.findIndex((r) => r._id === id);
          if (idx >= 0) {
            restos[idx].restaurantName = restoData.restaurantName;
            restos[idx].city = restoData.city;
            localStorage.setItem("restaurants", JSON.stringify(restos));
            localStorage.setItem("restaurantName", restoData.restaurantName);
          }
        } catch (e) {}
        this.getMonProfil();
      });
  };

  /* Modification du logo */
  modifProfilLogo = (e) => {
    e.preventDefault();
    const data = new FormData(e.target);

    const headers = new Headers({
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "PUT",
      body: data,
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/restaurateur/profil/edit/logo",
      options
    )
      .then((response) => {
        return response.json();
      })

      .then(
        (responseObject) => {
          this.setState({ message: responseObject.message });
          this.getMonProfil();
        },

        (error) => {
        }
      );
  };

  postParrainage = (e) => {
    e.preventDefault();
    const data = {
      email: this.state.email,
    };

    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("token"),
      "x-restaurant-id": localStorage.getItem("restaurantId"),
    });

    const options = {
      method: "POST",
      body: JSON.stringify(data),
      headers: headers,
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/serveur/emailParrainage?_id=" +
        this.state.email +
        "&mailSender=" +
        this.state.profil.email,
      options
    )
      .then((response) => {
        return response.json();
      })

      .then((responseData) => {
        this.setState({ message: responseData.message });
      });
  };

  putProfilOnClick = () => {
    this.modifProfil();
  };

  componentDidMount() {
    this.getMonProfil();

  }

  render() {
    return (
      <Container className="styleProfil parrainage">
        <UploadPicture />
        <Row>
          <Col md={12} className="formProfil ">
            <h1 className="title">Données de l'établissement</h1>
            <p>
              {this.state.editing ? (
                <h1 className="textProfilTitre">
                  {this.state.profil.restaurantName}
                </h1>
              ) : (
                <input
                  type="text"
                  Value={this.state.profil.restaurantName}
                  name="restaurantName"
                  onChange={this.handleInput}
                />
              )}
            </p>
            <p>
              {this.state.editing ? (
                <span className="textProfil">{this.state.profil.adress}</span>
              ) : (
                <input
                  type="text"
                  name="adress"
                  placeholder="Adresse"
                  onChange={this.handleInput}
                  Value={this.state.profil.adress}
                />
              )}
            </p>
            <p>
              {this.state.editing ? (
                <span className="textProfil">
                  {this.state.profil.postal} - {this.state.profil.city}
                </span>
              ) : (
                <span className="cpVilleRow">
                  <input
                    type="text"
                    name="postal"
                    placeholder="Code postal"
                    onChange={this.handleInput}
                    Value={this.state.profil.postal}
                  />
                  <input
                    type="text"
                    name="city"
                    placeholder="Ville"
                    onChange={this.handleInput}
                    Value={this.state.profil.city}
                  />
                </span>
              )}
            </p>
            {this.state.editing ? (
              <div>
                <span className="textProfil">
                  Pourboire Général :{" "}
                  {this.state.profil.pourboireGeneral ? (
                    <span className="boolOui">✓</span>
                  ) : (
                    <span className="boolNon">✗</span>
                  )}
                </span>
                <br />
                <span className="textProfil">
                  Pourboire Individuel :{" "}
                  {this.state.profil.pourboireIndividuel ? (
                    <span className="boolOui">✓</span>
                  ) : (
                    <span className="boolNon">✗</span>
                  )}
                </span>
              </div>
            ) : (
              <div>
                <div>
                  <input
                    className="labelMargin"
                    type="checkbox"
                    id="individuel"
                    name="individuel"
                    checked={this.state.checkIndividuel}
                    onChange={() => {
                      this.setState({
                        checkIndividuel: !this.state.checkIndividuel,
                      });
                    }}
                  />
                  <label for="individuel">Pourboire individuel</label>
                </div>
                <div>
                  <input
                    className="labelMargin"
                    type="checkbox"
                    id="general"
                    name="general"
                    checked={this.state.checkGeneral}
                    onChange={() => {
                      this.setState({ checkGeneral: !this.state.checkGeneral });
                    }}
                  />
                  <label className="labelMargin" for="general">
                    Pourboire Général
                  </label>
                </div>
              </div>
            )}

            {this.buttonEdit()}

            {this.buttonCancel()}
          </Col>
          {/* {  <Row>
            <Col className="colParrainage">
              <Row>
                <Col md={12}>
                  <label className="demandeParrainage">
                    Parrainer un Serveur et/ou Restaurateur
                  </label>
                </Col>
              </Row>
              <Row className="rowParrain">
                <Col>
                  <input
                    type="text"
                    name="email"
                    onChange={this.handleInput}
                    placeholder="Email du parrainé"
                    className="inputParrainage"
                  />
                </Col>
                <Col>
                  <input
                    type="submit"
                    value="Envoyer"
                    onClick={this.postParrainage}
                    className="buttonParrainage"
                  />
                  <p className="infoParrainage">
                    " Vous êtes satisfaits : parlez-en autour de vous ! A chaque
                    parrainage d'un restaurateur, vous et votre confrère gagnez
                    2 mois d'abonnements Premium "
                  </p>
                </Col>
              </Row>
            </Col>
          </Row>} */}
          <Col className="formProfil nomProfil center">
            <h1 className="title">Mes QR Codes </h1>
            <Row className="rowCenter">
              <Col xs={6} md={6}>
                <p>QR CODE pourboire de votre établissement </p>
                <p className="qrSub">
                  à insérer sur vos tickets d'addition depuis votre logiciel de
                  caisse
                </p>

                <QrCodeTicket
                  className="qrCodeTicket"
                  restaurantName={localStorage.getItem("propsRestaurant")}
                />
              </Col>
            </Row>
            <Row className="rowCenter">
              <Col xs={6} md={6}>
                <p className="qr"> QR CODE carte </p>
                <p className="qrSub">
                  À télécharger pour impression sur vos supports ou insertion
                  dans votre logiciel de caisse ou d'encaissement.
                </p>

                <QrCode
                  className="qrCode"
                  restaurantName={localStorage.getItem("propsRestaurant")}
                />
              </Col>
            </Row>

            <br />
            <Button
              onClick={() => {
                window.confirm("Voulez vous vous déconnecter ?");

                this.props.setLogin(false);
                this.props.history.push("/");
              }}
              className="signOut1 button"
            >
              Déconnexion
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default Profil;
